import "./About.css";
import { useEffect } from "react";

const About = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://polyring.ch/embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="about-site-container">
      <div className="about-container">
        <h1>About me</h1>
        <p>
          My name is Owen Du and I am currently studying at ETH Zurich. I am
          currently a MSc Data Science student and finished my Bachelor's in
          Computer Science at ETH.
        </p>
        <p>
          Originally from Vienna, Austria, with roots in China, I came to Zurich
          in Autumn of 2020 to pursue studies at ETH Zurich. My interests
          outside of Computer Science include basketball, gaming and music
          (singing, dancing, guitar, DJ).
        </p>
        <p>
          Feel free to check out my social media below in the footer for some
          impressions of my life.
        </p>
        <div>
          <webring-banner>
            <p>
              Member of the <a href="https://polyring.ch">Polyring</a> webring
            </p>
          </webring-banner>
        </div>
        <h2>About this site</h2>
        <p>
          I started working on this website in February 2022. This is my first
          project using React and my first "big" project in web development. In
          the projects tab you will find projects I published, for now graphical
          implementations of interesting algorithms I discovered, mostly from
          lectures. In the blog tab there will be posts accompanying projects or
          articles about other interesting topics.
        </p>
      </div>
    </div>
  );
};

export default About;
